import { render } from "./InitialLoading.vue?vue&type=template&id=2cf79403&scoped=true"
import script from "./InitialLoading.vue?vue&type=script&lang=js"
export * from "./InitialLoading.vue?vue&type=script&lang=js"

import "./InitialLoading.vue?vue&type=style&index=0&id=2cf79403&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cf79403"]])

export default __exports__